import moment from "moment-timezone";

export const IST = 'Asia/Kolkata';

const DEFAULT_FORMAT = 'MMM Do YYYY hh:mm A z' ;
const DEFAULT_FORMAT_TIME = 'HH:mm z';

// Legacy aliases mapping (normalize to IANA names)
const ALIASES = {
   'Asia/Calcutta': 'Asia/Kolkata',
   'US/Eastern': 'America/New_York',
   'US/Central': 'America/Chicago',
   'US/Pacific': 'America/Los_Angeles',
   'US/Mountain': 'America/Denver'
};

const normalizeTimezone = (tz) => {
   let timezone = tz
   if (typeof (tz) !== 'string') {
      timezone = tz?.value;
   }

   return ALIASES[timezone] || timezone

}

const isValidTimezone = (tz) => moment.tz.zone(tz) !== null;

export const getLocalTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimezoneFromInterviewData = (data = {}) => {
   const interviewPreferredSlotsTimezone = (data?.interview_details?.interview_status === "UNSCHEDULED" && data?.interview_details?.preferred_slots_json?.length > 0)
      ? data?.interview_details?.preferred_slots_json[0]?.input_tz
      : ((data?.interviews?.[0]?.interview_status === "UNSCHEDULED" && data?.interviews?.[0]?.preferred_slots_json?.length > 0)
         ? data?.interviews?.[0]?.preferred_slots_json[0]?.input_tz
         : null);
   const candidateTimezone = data?.candidate_details?.extra_info?.timezone?.value || data?.candidate?.extra_info?.timezone?.value || null
   const interviewExtraInfoTimezone = data?.interview_details?.extra_info?.timezone || data?.interviews?.[0]?.extra_info?.timezone || null;
   const positionTimezone = data?.position_details?.extra_info?.timezone?.value || data?.position?.extra_info?.timezone?.value || null
   const clientTimezone = data?.client_details?.config_?.timezone?.value || data?.client?.config_?.timezone?.value || null
   const clientAdminTimezone = data?.client_details?.user?.user_config?.timezone || data?.client?.user?.user_config?.timezone || null
 
   let tz = getTimezoneForInterviewCreation({
      candidateTimezone: candidateTimezone,
      interviewTimezone: interviewExtraInfoTimezone,
      positionTimezone: positionTimezone,
      clientTimezone: clientTimezone,
      clientUserTimezone: clientAdminTimezone,
      interviewPreferredSlotsTimezone: interviewPreferredSlotsTimezone
   })

   return tz;
};

export const getTimezoneForInterviewCreation = ({candidateTimezone, interviewTimezone, positionTimezone, clientTimezone, clientUserTimezone, interviewPreferredSlotsTimezone}) => {
    let tz = interviewPreferredSlotsTimezone ||
      candidateTimezone ||
      interviewTimezone ||
      positionTimezone ||
      clientTimezone ||
      clientUserTimezone ||
      getLocalTimezone();

   tz = normalizeTimezone(tz);

   if (!isValidTimezone(tz)) {
      console.warn(`Invalid timezone "${tz}". Falling back to IST (${IST}).`);
      return IST;
   }

   return tz;
}

export const showDualTimestamp = (data) => {
    const tz = getTimezoneFromInterviewData(data);
   return !isIndianTimezone(tz);    
}

export const formatEpochToTime = (epoch, timeZone, format = DEFAULT_FORMAT) => {
   const normalizedTZ = normalizeTimezone(timeZone);
   const finalTZ = isValidTimezone(normalizedTZ) ? normalizedTZ : IST;
   const date = moment.unix(epoch < 1e12 ? epoch : epoch / 1000); // handles sec & ms
   const m =  date.tz(finalTZ);

 if (format.includes("z")) {
    // Get abbreviation or offset
    const abbr = m.format("z");
    const offset = m.format("Z");
    const readableZ = /^[\+\-]\d{2}(:?\d{2})?$/.test(abbr)
      ? `(GMT${offset})`
      : abbr;

    // Replace the literal 'z' in the format string with our computed value
    return m.format(format.replace("z", `[${readableZ}]`));
  }
  return m.format(format);
};

export const formatEpochToTimestamp = (epoch, format = DEFAULT_FORMAT) => {
   const date = moment.unix(epoch < 1e12 ? epoch : epoch / 1000); // handles sec & ms
  return date.format(format);
};

export const getISTTime = (epoch, format = DEFAULT_FORMAT) => {
   const istTime = formatEpochToTime(epoch, IST, format);
   return istTime;
};

export const getISTAndClientTimes = (epoch, hierarchy = {}, format = DEFAULT_FORMAT) => {
   const clientTZ = getTimezoneFromInterviewData(hierarchy);
   const istTime = formatEpochToTime(epoch, IST, format);
   const clientTime = formatEpochToTime(epoch, clientTZ, format);
   return { istTime: istTime, clientTime: clientTime, clientTimezone: clientTZ };
};

export const isIndianTimezone = (tz) => {
   let timezone = tz || getLocalTimezone();
   const normalizedTZ = normalizeTimezone(timezone);
   const finalTZ = isValidTimezone(normalizedTZ) ? normalizedTZ : IST;
   return finalTZ === IST;
};

export const getAbbreviationWithGMT = (tz) => {
   const normalizedTZ = normalizeTimezone(tz);
   const finalTZ = isValidTimezone(normalizedTZ) ? normalizedTZ : IST;
   return moment().tz(finalTZ).format(`z ([GMT]Z)`)
};

export const convertTimeBetweenTimezones = (
  timeStr,
  {fromTZ=IST,
  toTZ,
  outputFormat = DEFAULT_FORMAT_TIME }={}
) => {
// Attach today's date to handle parsing properly
  const today = moment().format('YYYY-MM-DD');
  const fullTime = `${today} ${timeStr}`;

  const sourceTime = moment.tz(fullTime, ['YYYY-MM-DD h:mm A', 'YYYY-MM-DD HH:mm'], fromTZ);
  if (!sourceTime.isValid()) return 'Invalid time';
  return sourceTime.clone().tz(toTZ).format(outputFormat); // e.g., "02:00 PM PDT"
};